<h1 mat-dialog-title>Coupon</h1>

<div mat-dialog-content>
  <app-coupon-form [coupon]="coupon"></app-coupon-form>
</div>
<div mat-dialog-actions>
  <span fxFlex></span>
  <button mat-button (click)="close()">Annulla</button>
  <button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="coupon"
    cdkFocusInitial
  >
    Ok
  </button>
</div>
